export default __webpack_public_path__ + "media/images/images/elements/04-acc66ed35cd09d1e6d9c19d23f01e20e.png";